import {useState,useMemo,useEffect,useCallback} from "react";
import {Stack,Button} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {useSnackbar} from '../SnackbarContext.js';
import {useLoading} from '../LoadingContext';
import {consoleLog,dateFns_to_db} from '../../../core/utilities/Utilities.js';
import {generateReport,downloadWorkdayExcel} from '../../integration/Api.js';
import COMPONENT_MAP from '../Repository/Components.js';
const file='ReportDetailWorkdayHours.js';

//Workday timer report - one row per employee per day (minutes per work type, breaks, sick leave) + Excel export
const ReportDetailWorkdayHours=({userData,application})=>{
    const [loading,setLoading]=useState(false);
    const [rows,setRows]=useState([]);
    const [dateFilter,setDateFilter]=useState({
        start:new Date(new Date().getFullYear(),new Date().getMonth(),1),
        end:new Date()
    });
    const {showSnackbar}=useSnackbar();
    const {showLoading,hideLoading}=useLoading();
    const lang=application?.globalData?.lang;

    const reportParams=useMemo(()=>(
        ["start_date="+dateFns_to_db(dateFilter.start),"end_date="+dateFns_to_db(dateFilter.end),'_lang='+lang]
    ),[dateFilter,lang]);

    const processGenerateReport=useCallback(()=>{
        setLoading(true);
        consoleLog({file:file,context:'processGenerateReport',arg_name:'reportParams',arg_value:reportParams});
        generateReport({reportType:'workday_hours',reportParams:reportParams})
        .then((data)=>{
            consoleLog({file:file,context:'processGenerateReport - generate_report',arg_name:'data',arg_value:data});
            if('error' in data){
                showSnackbar(data.error,'error');
            }
            else if(data.length>0){
                setRows(old=>data);
            }
            else{
                setRows(old=>[]);
            }
            setLoading(false);
        });
    },[reportParams,showSnackbar]);

    useEffect(()=>{
        processGenerateReport();
    },[dateFilter,processGenerateReport]);

    const handleDownloadExcel=useCallback(async()=>{
        showLoading();
        const data=await downloadWorkdayExcel(reportParams);
        hideLoading();
        if(data?.error){
            showSnackbar(data.error,'error');
        }
    },[reportParams,showLoading,hideLoading,showSnackbar]);

    const renderFilter=useCallback(()=>{
        const Component=COMPONENT_MAP['FilterDate'];
        return Component?(
            <Stack direction={{xs:'column',sm:'row'}} spacing={1} alignItems={{xs:'flex-start',sm:'center'}}>
                <Component
                    dateFilter={dateFilter}
                    setDateFilter={setDateFilter}
                    application={application}
                />
                <Button size="small" variant="contained" startIcon={<FileDownloadIcon/>} onClick={handleDownloadExcel}>{application.getLocale("ButtonDownloadExcel")}</Button>
            </Stack>
        ):null;
    },[dateFilter,application,handleDownloadExcel]);

    const handleClickEvent=useCallback((args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'click_event',arg_value:args});
        switch(args?.action){
            case "generateReport":
                setRows(old=>[]);
                processGenerateReport();
                break;
            default:
                break;
        }
    },[processGenerateReport]);

    const renderList=useMemo(()=>{
        const Component=COMPONENT_MAP['List'];
        return Component?(
            <Component
                records={rows}
                list_name={'report_workday_hours'}
                loading={loading}
                height={window.innerHeight-170}
                file={file}
                application={application}
                initialState={{}}
                entityRules={{noData:'true'}}
                userData={userData}
                actions={{}}
                handleClickEvent={handleClickEvent}
                filterComponent={renderFilter()}
                noRefresh={true}
            />
        ):null;
    },[rows,loading,application,userData,handleClickEvent,renderFilter])

    return(renderList);
}

export default ReportDetailWorkdayHours;
